<content-loader
  [backgroundColor]="'var(--bgColor-muted)'"
  [foregroundColor]="'var(--data-gray-color-muted)'"
  [baseUrl]="baseUrl"
  [speed]="3"
  [viewBox]="viewBox"
>
  <ng-content></ng-content>
</content-loader>
